import React from 'react';

const TimelineContributorNotice: React.FC = () => {
  return (
    <div className="timeline-view-contributor-notice">
      <wa-callout>
        <i className="fa-regular fa-user-plus" slot="icon"></i>
        <strong>You're a contributor on this Timeline</strong><br />
        You can add your own memories. The owner will be notified when you contribute.
      </wa-callout>
    </div>
  );
}

export default TimelineContributorNotice;
